<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.25 3A2.261 2.261 0 0 0 2 5.25V7.5h13.5V5.25c0-.425.325-.75.75-.75.424 0 .75.325.75.75v13.5c0 .264.055.513.141.75H6.5a.737.737 0 0 1-.75-.75V8.25h-1.5v10.5A2.262 2.262 0 0 0 6.5 21h12.75a2.262 2.262 0 0 0 2.25-2.25V16.5h-3V5.25A2.262 2.262 0 0 0 16.25 3h-12Zm0 1.5h9.891c-.09.24-.138.494-.141.75V6H3.5v-.75c0-.425.325-.75.75-.75ZM18.5 18H20v.75c0 .424-.326.75-.75.75a.737.737 0 0 1-.75-.75V18Z"
            fill="#333"></path>
        <path
            d="M10.875 18h1.25v-.9h1.25c.18 0 .33-.064.448-.191a.684.684 0 0 0 .177-.484V13.5a.684.684 0 0 0-.177-.484.584.584 0 0 0-.448-.191H10.25V11.25H14V9.9h-1.875V9h-1.25v.9h-1.25c-.18 0-.33.064-.448.191a.684.684 0 0 0-.177.484V13.5c0 .195.059.356.177.484a.584.584 0 0 0 .448.191h3.125v1.575H9v1.35h1.875v.9Z"
            fill="#333"></path>
    </svg>
</template>
<script>
export default {
    name: 'IconPriceRules',
};
</script>
